














































































































































































































/* 
  getTeacherDetailInfo 查看教师详情信息
  saveOrUpdate 保存或编辑教师信息
*/
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  getTeacherDetailInfo,
  saveOrUpdate
} from "../../../../api/teacherInfoManage";
import { getToken } from "../../../../utils/auth";

//自定义对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "detail"
})
export default class extends Vue {
  @Prop(String) otherinfoProjectId!: string;
  @Prop(String) otherinfoSourceId!: string;
  @Prop(String) teacherId!: string;
  private teacherInfoVo: CustomForm = {}; //详情数据
  private historyEmployInfoVos: CustomForm[] = []; //历次聘用信息表格
  private imageUrl: string = ""; //头像地址
  // 后来添加的上传需要的参数
  private upload = {
    header: {
      Authorization: getToken(),
      access_token: getToken()
    },
    fileList: []
  };

  created() {
    this.getDetail();
  }

  //上传地址
  get uploadUrl() {
    return (
      window.config.baseUrl4Shool + "/baseinfo/teacherinfo/upLoadHeadImage"
    );
  }

  //获取详情数据
  private async getDetail() {
    try {
      let res = await getTeacherDetailInfo({
        otherinfoProjectId: this.otherinfoProjectId,
        otherinfoSourceId: this.otherinfoSourceId,
        teacherId: this.teacherId
      });
      this.teacherInfoVo = res.data.teacherInfoVo;
      this.historyEmployInfoVos = res.data.historyEmployInfoVos;
    } catch (error) {
      // this.$message.error(error || "获取详情失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private handleAvatarSuccess(res: any) {
    try {
      if (res.code != "20000000") {
        this.$message.error(res.mesg);
      }
      this.teacherInfoVo.teacherPhotoPath = res.data;
      this.$forceUpdate();
    } catch (error) {
      // this.$message.error(error || "上传失败！");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private beforeAvatarUpload(file: any) {
    const isJPG = file.type === "image/jpeg";
    const isJPG2 = file.type === "image/jpg";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG || isJPG2) {
      this.$message.error("上传头像图片只能是 JPG 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  //保存处理
  private async saveHandle() {
    let params = {
      otherinfoIntroduction: this.teacherInfoVo.otherinfoIntroduction, //简介
      otherinfoIsExcellentTeacher: this.teacherInfoVo
        .otherinfoIsExcellentTeacher, //是否优秀教师 0:是 1:否
      otherinfoIsRecommend: this.teacherInfoVo.otherinfoIsRecommend, //是否推荐 0:推荐, 1:不推荐
      otherinfoProjectId: this.teacherInfoVo.projectId, //项目id
      otherinfoSourceId: this.teacherInfoVo.otherinfoSourceId, //来源id
      otherinfoSubject: this.teacherInfoVo.subjectId, //科目
      teacherAddress: this.teacherInfoVo.teacherAddress, //地址
      teacherAge: this.teacherInfoVo.teacherAge, //年龄
      teacherBirthday: this.teacherInfoVo.teacherBirthday, //出生年日
      teacherCard: this.teacherInfoVo.teacherCard, //身份证号
      teacherDistrictId: this.teacherInfoVo.teacherDistrictId, //市县id
      teacherEmail: this.teacherInfoVo.teacherEmail, //邮箱
      teacherGenderId: this.teacherInfoVo.teacherGenderId, //性别id
      teacherGradeId: this.teacherInfoVo.teacherGradeId, //任课年级
      teacherId: this.teacherInfoVo.teacherId, //教师信息id
      teacherName: this.teacherInfoVo.teacherName, //教师姓名
      teacherPhone: this.teacherInfoVo.teacherPhone, //手机号
      teacherPhotoPath: this.teacherInfoVo.teacherPhotoPath, //头像路径
      teacherProfessionalId: this.teacherInfoVo.teacherProfessionalId, //职称
      teacherSchoolId: this.teacherInfoVo.teacherSchoolId, //所属学校id (单位)
      teacherTeachingAge: this.teacherInfoVo.teacherTeachingAge //教龄
    };
    // TODO：还缺少 开户行、银行卡号
    try {
      await saveOrUpdate(params);
      this.$message.success("保存成功");
    } catch (error) {
      // this.$message.error(error || "保存失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //返回处理
  private backHandle() {
    //刷新列表
    (this.$parent as any).getData();
    (this.$parent as any).showDetail = false;
  }
}
